import { render, staticRenderFns } from "./ScoringDrillMath.vue?vue&type=template&id=0157a2bb&scoped=true&lang=pug&"
import script from "./ScoringDrillMath.vue?vue&type=script&lang=ts&"
export * from "./ScoringDrillMath.vue?vue&type=script&lang=ts&"
import style0 from "./ScoringDrillMath.vue?vue&type=style&index=0&id=0157a2bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0157a2bb",
  null
  
)

export default component.exports